<template>
  <span>
    <v-text-field
      v-model="car.mileage"
      :suffix="mileageSpeedometer(car.speedometer)"
      :rules="[$rules.isRequired]"
      label="走行距離 *"
      type="number"
      @blur="({ target }) => updateCar({ field: 'mileage', value: target.value })"
    />
    <cp-radio
      v-model="car.speedometer"
      :items="speedometerItems"
      :rules="[$rules.isRequired]"
      label="距離単位 *"
      @change="(val) => updateCar({ field: 'speedometer', value: val })"
    />
    <v-dialog
      v-model="dialog"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-spacer />
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0 text-xs-center">マイル表示でよろしいですか?</v-card-text>
        <v-card-actions class="pb-3">
          <v-spacer/>
          <v-btn
            color="error"
            outline
            @click.native="onMilesDisagree"
          >いいえ</v-btn>
          <v-btn
            color="primary"
            outline
            @click.native="dialog = false"
          >はい</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  props: {
    appointment: {
      type: Object,
      default: () => {},
    },
    car: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isSubForm: true,
      speedometerItems: [
        {
          text: 'キロ',
          value: 'KM',
        },
        {
          text: 'マイル',
          value: 'MILES',
        },
      ],
      dialog: false,
    };
  },
  computed: {
    speedometer() {
      return this.car.speedometer;
    },
  },
  watch: {
    speedometer(v) {
      this.dialog = v === 'MILES';
    },
  },
  methods: {
    mileageSpeedometer(current) {
      const item = this.speedometerItems.find(i => i.value === current);

      return item ? item.text : '';
    },
    onMilesDisagree() {
      this.car.speedometer = null;
      this.updateCar({ field: 'speedometer', value: this.car.speedometer });
      this.dialog = false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/fields/MileageData.vue